export default "__VITE_ASSET__DwwtU1tC__"